import { useEffect, useState } from 'react';
import Sheet from 'react-modal-sheet';
import wizard from '../assets/yettelPetak/wizard.png';
import Button from './Button';
import { SESSION_STORAGE_KEYS } from '../constants/sessionStorageKeys';
import { UNUSED } from '../constants/scratchCard';
import YettelPetakScratchCardModal from './YettelPetakScratchCardModal';
import { ScratchOfferResponse, YSH_GTM_EVENTS } from '../types/types';
import YettelPetakConsentModal from './YettelPetakConsentModal';
import { pushToAnalytics } from '../utils/analytics';
import { LOCAL_STORAGE_KEYS } from '../constants/localStorageKeys';
import close from '../assets/images/icons/icon-close.svg';
import '../scss/yettel-petak-wizard-modal.scss';

type Props = {
  scratchOffer?: ScratchOfferResponse;
};
const YettelPetakWizardModal: React.FC<Props> = ({ scratchOffer }: Props) => {
  const userMarketingConsent = localStorage.getItem(
    LOCAL_STORAGE_KEYS.USER_CONSENT_DIRECT_MARKETING_CONSENTED
  );

  const [isWizardModalActive, setIsWizardModalActive] = useState(true);
  const [isConsentModalActive, setIsConsentModalActive] = useState(false);
  const [isScratchCardActive, setIsScratchCardActive] = useState(false);

  const showScratchCardModal = scratchOffer?.data;

  useEffect(() => {
    pushToAnalytics({
      eventName: YSH_GTM_EVENTS.SCRATCH_AND_WIN_NOTIFICATION,
      data: {}
    });
  }, []);

  const onCloseWizardYettelPetakPopup = () => {
    sessionStorage.setItem(
      SESSION_STORAGE_KEYS.IS_WIZARD_YETTEL_PETAK_MODAL_SEEN,
      'true'
    );
    setIsWizardModalActive(false);
  };

  const onClickOpenScratch = () => {
    if (userMarketingConsent !== '0') {
      if (scratchOffer?.data?.status === UNUSED) {
        setIsWizardModalActive(false);
        setIsScratchCardActive(true);
      }
    } else {
      setIsWizardModalActive(false);
      setIsConsentModalActive(true);
    }
  };

  return (
    <>
      <Sheet
        isOpen={isWizardModalActive}
        onClose={onCloseWizardYettelPetakPopup}
        className="wizard-modal"
      >
        <Sheet.Container>
          <Sheet.Header>
            <div className="d-flex justify-content-end pt-3">
              <img
                className="cursor-pointer"
                width={25}
                height={25}
                src={close}
                alt="close modal"
                onClick={onCloseWizardYettelPetakPopup}
              />
            </div>
          </Sheet.Header>
          <Sheet.Content>
            <WizardContent onClickOpenScratch={onClickOpenScratch} />
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={onCloseWizardYettelPetakPopup} />
      </Sheet>

      <YettelPetakConsentModal
        isModalActive={isConsentModalActive}
        setIsModalActive={setIsConsentModalActive}
        setIsWizardModalActive={setIsWizardModalActive}
        setIsScratchCardActive={setIsScratchCardActive}
      />

      {showScratchCardModal && (
        <YettelPetakScratchCardModal
          scratchOffer={scratchOffer.data}
          isModalActive={isScratchCardActive}
          setIsModalActive={setIsScratchCardActive}
        />
      )}
    </>
  );
};

interface WizardContentProps {
  onClickOpenScratch: () => void;
}

const WizardContent: React.FC<WizardContentProps> = ({
  onClickOpenScratch
}) => {
  return (
    <>
      <img
        className="yettel-petak-wizard-image"
        alt="scratch"
        src={wizard}
        onClick={onClickOpenScratch}
      />
      <Button className="mt-3" onClick={() => onClickOpenScratch()}>
        Ogrebi i osvoji
      </Button>
    </>
  );
};

export default YettelPetakWizardModal;
